import { CoreComponentsContext } from "./core-components";

export function CompletionIndicator({
  isDropped,
  isComplete,
  hasPendingActions,
}: {
  isDropped?: boolean;
  isComplete: boolean;
  hasPendingActions: boolean;
}) {
  return (
    <CoreComponentsContext.Consumer>
      {({ Text }) =>
        isDropped ? (
          <Text>❌</Text>
        ) : isComplete ? (
          hasPendingActions ? (
            <Text style={{ color: "#FD8D0E" }}>⬤</Text>
          ) : (
            <Text>✅</Text>
          )
        ) : null
      }
    </CoreComponentsContext.Consumer>
  );
}
